module.exports = __webpack_public_path__ + "img/富坚勇树.97869594.png";